import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { defineMessages } from 'react-intl-next';
export var EditUserPickerMessage = /*#__PURE__*/function (EditUserPickerMessage) {
  EditUserPickerMessage["UserPickerStartTyping"] = "UserPickerStartTyping";
  return EditUserPickerMessage;
}({});
export var IntlEditUserPickerMessages = defineMessages(_defineProperty({}, EditUserPickerMessage.UserPickerStartTyping, {
  id: 'form-system.UserPicker.UserPickerStartTyping',
  defaultMessage: 'Start typing to search for users'
}));